import { Helmet } from 'react-helmet';
import WithdrawForm from '../../components/withdrawals/WithdrawForm';

const WithdrawPage = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Withdraw - Global Triumph Market Plus Multiconcept</title>
        <meta
          name="description"
          content="User password editing page on Global Triumph Market Plus Multiconcept - Real estate investments and properties, properties for sales"
        />
      </Helmet>
      <div className="profile">
        <h1 className="pageTitle">Withdraw From Your Eanings</h1>
        <h3 className="subtitle">You can withdraw from your earning balance from here</h3>
        <WithdrawForm />
      </div>
    </>
  );
};

export default WithdrawPage;
